import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@app/auth/auth.service';
import { config } from '@app/app.config';

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  buffer = [];

  constructor(private http: HttpClient,
      private authService: AuthService) {
  }

  async beginServerSideRecording() {
    await this.http
      .post<string[]>(
          config.httpURL + `/api/event/record`,
          undefined,
          { headers: { Authorization: `Bearer ${this.authService.getAccessToken()}` }}
      ).subscribe();
  }

  captureAudio(data: any) {
    this.buffer.push(data);
  }

  playbackAudio() {
    const reader = new FileReader();
    reader.onload = function(e) {
      // e.targer.result will hold the base64 data.
      // Note: It includes the pre-text "data:audio/<format>;base64,<base64 data>"
      // Then do

      const audio = document.getElementById('audio');
      const source = document.getElementById('source');

      // @ts-ignore
      audio.src = e.target.result;

      // Insert blob object URL into audio element & play.
      // @ts-ignore
      audio.load();
      // @ts-ignore
      // audio.play();
    };

    const blob = new Blob(this.buffer, { type: 'audio/wav' });
    // console.log(blob);
    reader.readAsDataURL(blob);
  }

  resetAudioBuffer() {
    this.buffer = [];
  }

  postAnalytics(type: string, eventId?: string) {
    const url = `${config.httpURL}/api/analytics`;
    const payload = JSON.stringify({
      type: type,
      url: location.href,
      ts: Date.now()//,
      //event: eventId
    });

    const blob = new Blob([payload], { type: "application/json"});

    navigator.sendBeacon(url, blob);
  }
}
